<template>
  <input
    :id="name"
    :class="{ 'is-invalid': errors }"
    :name="name"
    :placeholder="label"
    :readonly="readonly"
    :required="required"
    type="text"
    :value="modelValue"
    class="form-control"
    autocomplete="off"
    @change="$emit('update:data', $event.target.value)"
  />
</template>

<script>
export default {
  props: {
    attribute: { type: String, default: null },
    errors: { type: Array, default: null },
    name: { type: String, default: '' },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    label: { type: String, default: '' },
    modelValue: { type: String, default: '' },
  },
  emits: ['update:data'],
  setup() {},
};
</script>
